export const CognitoConfig = {
    region: 'us-east-1',
    userPoolId: 'us-east-1_3bgSgAUTS',
    userPoolWebClientId: '6drpvo6sh74abnps4ulri46j38',
    oauth: {
        domain: 'pflix.auth.us-east-1.amazoncognito.com',
        scope: ['openid', 'email', 'profile'],
        redirectSignIn: `${window.location.origin}`,
        redirectSignOut: `${window.location.origin}`,
        responseType: 'code',
        urlOpener: (rawUrl: string) => {
            const u = new URL(rawUrl);
            u.searchParams.set('identity_provider', 'PFlix');
            const tried = sessionStorage.getItem('gobotSilentTried') === '1';
            if (!tried) {
                u.searchParams.set('prompt', 'none');
                sessionStorage.setItem('gobotSilentTried', '1');
            } else {
                u.searchParams.delete('prompt');
            }

            window.location.replace(u.toString());
        },
    },
};